/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
  useCustomCursor: false,
  googleTrackingID: "",
};

//SEO Related settings
const seo = {
  title: "Yousef Injas | Software Developer & IT Specialist",
  description:
    "Portfolio of Yousef Injas — Computer Science graduate from Birzeit University specializing in Full-Stack Development, Frontend Engineering, and IT systems.",
  og: {
    title: "Yousef Injas | Software Developer & IT Specialist",
    type: "website",
    url: "https://github.com/injasyousef",
  },
};

//Home Page
const greeting = {
  title: "Yousef Injas",
  heroText: "Yousef Injas",
  logo_name: "Yousef Injas",
  nickname: "",
  subTitle:
    "Motivated Computer Science graduate from Birzeit University with strong experience in full-stack development, frontend engineering, and IT support. Passionate about building reliable, scalable, and user-friendly software solutions.",
  resumeLink: "/Yousef_Injas_CV.pdf",
  portfolio_repository: "https://github.com/injasyousef",
  githubProfile: "https://github.com/injasyousef",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/injasyousef",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/yousef-injass-386132274/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:injasyousef5@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=100004890609106",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/yousef.abuhalaweh/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/InjassYousef",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?style=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
];

const skills = {
  data: [
    {
      title: "Frontend Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Building responsive, user-friendly interfaces with React and Angular",
        "⚡ HTML/CSS 90% · JavaScript / TypeScript 85%",
      ],
      softwareSkills: [
        {
          skillName: "React",
          fontAwesomeClassname: "logos:react",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "logos:angular-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "logos:typescript-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "logos:bootstrap",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Backend Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing and building scalable APIs and server-side applications",
        "⚡ SQL 80% · REST API design and integration",
      ],
      softwareSkills: [
        {
          skillName: "Django",
          fontAwesomeClassname: "logos:django-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "logos:spring-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "ASP.NET",
          fontAwesomeClassname: "logos:dotnet",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "logos:flask",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Programming Languages",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Python 85% · Java 80% · C# 75% · PHP 70% · C 65%",
        "⚡ Comfortable moving between object-oriented and scripting languages",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "logos:php",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "simple-icons:csharp",
          style: {
            color: "#239120",
          },
        },
      ],
    },
    {
      title: "Tools & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Version control, containerisation, and API testing in day-to-day workflows",
        "⚡ Administering and troubleshooting Linux and Windows systems",
      ],
      softwareSkills: [
        {
          skillName: "Git",
          fontAwesomeClassname: "logos:git-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos:docker-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "logos:postman-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "logos:linux-tux",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Birzeit University",
      subtitle: "Bachelor of Computer Science",
      logo_path: "birzeit_logo.png",
      alt_name: "Birzeit University",
      duration: "Aug. 2020 - June 2024",
      descriptions: [],
      website_link: "https://www.birzeit.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Data Science",
      subtitle: "- Udacity (Online) · Jan 2025 - June 2025",
      fontAwesomeClassname: "simple-icons:udacity",
      color: "#02B3E4",
      certificate_link: "",
      alt_name: "Udacity",
      color_code: "#02B3E499",
    },
    {
      title: "Machine Learning",
      subtitle: "- STEAM Center, Amman, Jordan · Mar 2025",
      fontAwesomeClassname: "simple-icons:tensorflow",
      color: "#FF6F00",
      certificate_link: "",
      alt_name: "STEAM Center",
      color_code: "#F1C40F99",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work Experience and Internships",
  description:
    "I have worked across frontend development, full-stack engineering, and IT support roles, building responsive web applications and keeping business-critical systems reliable and secure.",
  header_image_path: "",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "IT Specialist",
          company: "Hclinic Specialty Hospital",
          company_url: "",
          logo_path: "",
          duration: "Jan 2025 - Present",
          location: "Ramallah, Palestine",
          description:
            "Installed, configured, and troubleshot operating systems, software, and hardware, ensuring system performance and reliability. Managed network security, firewall systems, data backups, and system documentation. Provided technical support and trained staff on IT systems.",
          color: "#0B5345",
        },
        {
          title: "Frontend Developer",
          company: "Aqlama.ai",
          company_url: "",
          logo_path: "",
          duration: "Feb 2026 - May 2026",
          location: "Ramallah, Palestine",
          description:
            "Developed the full frontend of the Aqlama AI Academy platform using React and TypeScript, building a responsive and user-friendly web application. Built a bilingual interface (Arabic & English) to showcase company services, academy courses, and instructors. Integrated the frontend with backend APIs and implemented authentication features including sign up, sign in, and token-based access.",
          color: "#1F618D",
        },
      ],
    },
    {
      title: "Internship",
      experiences: [
        {
          title: "Full-Stack Developer Intern",
          company: "Iconnect Technologies",
          company_url: "",
          logo_path: "iconnect_logo.png",
          duration: "Aug. 2023 - Nov. 2023",
          location: "Ramallah, Palestine",
          description:
            "Worked on backend development using C# and ASP.NET to build scalable web applications. Developed frontend features using JavaScript and Angular for dynamic interfaces. Applied cybersecurity principles to support data integrity and system security.",
          color: "#B9770E",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A selection of my work spanning full-stack web applications, cybersecurity tooling, and backend API development.",
  avatar_image_path: "",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile_photo_white.jpg",
    description:
      "I am available on almost every social media and email. Feel free to reach out — I can help you with Full-Stack Development, Frontend Engineering, and IT systems.",
  },
  blogSection: {
    title: "",
    subtitle: "",
    link: "",
    avatar_image_path: "",
  },
  addressSection: {
    title: "",
    subtitle: "",
    locality: "",
    country: "",
    region: "",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "",
    location_map_link: "",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+972595773402",
  },
};

// My Works Page
const works = {
  title: "My Works",
  subtitle: "Projects I've built",
  projects: [
    {
      id: 1,
      title: "CyberX Solutions",
      description:
        "AI-powered cybersecurity SaaS platform for network threat detection and botnet analysis. Built with multi-tenant architecture, advanced machine learning models, and enterprise-grade authentication.",
      logo: require("./assets/images/cyberx_logo.png"),
      liveUrl: "https://cyberxsolutions.co",
      color: "#0A2472",
    },
  ],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  works,
};
